<script>
import axios from 'axios';
import { consultingApiUrl, consultingApiKey } from '../variables';
import LoadIndicator from '@/components/LoadIndicator';

export default {
  name: 'ConversationConfirmPage',
  components: {
    LoadIndicator,
  },
  data() {
    return {
      data: null,
      isLoading: true,
      isSuccess: false,
      isError: null,
    }
  },
  mounted() {
    this.$store.dispatch('setSiteHeaderOpaque');
    this.$store.dispatch('showSiteFooter');
    this.init(this.$route.params.conversationId);
  },
  methods: {
    init(id) {
      axios.get(`${consultingApiUrl}/conversations/confirm/${id}`, 
        {
          headers: {
            Authorization: `Bearer ${consultingApiKey}`
          }
        })
        .then(() => {
          this.isSuccess = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isSuccess = false;
          this.isLoading = false;
          this.isError = true;
        });
    },
  },
};
</script>

<template>
  <section class="conversation-confirm-page">
    <div class="conversation-confirm-page__wrapper">
      <h1 class="conversation-confirm-page__title page-title">
        {{ $t('consultingConfirm.pageTitle') }}
      </h1>

      <load-indicator v-if="isLoading" />
      
      <div class="conversation-confirm-page__message" v-if="isSuccess">
        <p>Vielen Dank für Ihre Anfrage an die Angehörigenbegleitung  von «Leben mit Schizophrenie».</p>
        <p>In der Regel erhalten Sie innerhalb einer Woche eine Antwort. Für den Fall, dass uns sehr viele Anfragen erreichen, kann es länger dauern. Sobald die Antwort unseres Beratungsteams vorliegt, erhalten Sie eine E-Mail an die angegebene Adresse mit einem Link, wo Ihnen die Antwort angezeigt wird. Dieser Link ist für andere Personen nicht auffindbar. Bitte beachten Sie jedoch, dass Sie den Link per E-Mail an die angegebene Adresse erhalten. Falls andere Personen Zugriff darauf haben, können diese Ihre Anfrage und die Antwort unseres Beratungsteams einsehen.</p>
        <p>Bei Unklarheiten oder technischen Schwierigkeiten schreiben Sie uns bitte eine E-Mail an  <a href="mailto:beratung@lebenmitschizophrenie.ch">beratung@lebenmitschizophrenie.ch</a></p>
        <p>Hinweis: Bei akuten Notsituationen wenden Sie sich bitte an die Notfallnummern 144 (Notruf), 117 (Polizei) oder 147 (Telefonhilfe für Kinder und Jugendliche).</p>
      </div>

      <div class="conversation-confirm-page__error" v-if="isError">
        <p v-html="$t('consultingConfirm.error')"></p>
      </div>

    </div>

  </section>
</template>

<style lang="scss" scoped>
.conversation-confirm-page {
  @include page;
}

.conversation-confirm-page__wrapper {
  @include container-narrow;
}

.conversation-confirm-page__message,
.conversation-confirm-page__error {
  font-size: 1.8rem;
  letter-spacing: 0.032rem;
  line-height: 1.67;
}
</style>
